import Table from "../services/table";
import { TableManger } from "./TableManger";
import { isEmpty } from "deskera-ui-library";

export interface IState {
    contact: any;
    pipeline: any;
    stage: any;
    form: any;
}
export class StateManager {
    static state: IState = {
        contact: {},
        pipeline: {},
        stage: {},
        form: {},
    };
    static get(
        tableName: string,
        options = { pageNo: 1, pageSize: 20 },
        data = null,
        refresh = false,
        selectYear = false
    ): Promise<any> {
        if (refresh || isEmpty(this.state[tableName])) {
            return Table.getRecordsByPage(
                options,
                data,
                TableManger.getTableId(tableName)
            ).then((res) => {
                this.set(tableName, res);
                return Promise.resolve(res);
            });
        } else {
            // this.get(tableName, options, data, true);
            return Promise.resolve(this.state[tableName]);
        }
    }
    static set(tableName: string, data) {
        this.state[tableName] = data;
    }
    static clear(tableName: string) {
        this.set(tableName, {});
    }
}
